<template>
  <div class="success-page">
    <div class="success-card">
      <div class="success-icon">
        <i class="iconfont">&#xe681;</i>
      </div>
      <div class="title">{{ '提交成功' | dealLanguage('Submitted Successfully') }}</div>
      <div class="desc">
        {{ '您已成功提交摘要内容' | dealLanguage('Your abstract has been submitted successfully.') }}
      </div>
      <Button type="primary" class="view-btn" @click="$router.push({ name: 'contributionList' })">
        {{ '查看已提交的摘要' | dealLanguage('View Submitted Abstracts') }}
      </Button>
    </div>
  </div>
</template>
<script>
import filter from 'js/filter'

export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('提交成功', 'Submitted Successfully'),
    }
  },
}
</script>
<style lang='stylus' scoped>
.success-page
  min-height calc(100vh - 64px)
  display flex
  align-items center
  justify-content center
  padding 40px 20px
  background #F7F7F7

.success-card
  width 100%
  max-width 420px
  text-align center

.success-icon
  width 108px
  height 108px
  margin 0 auto
  border 8px solid #2BC15D
  border-radius 50%
  display flex
  align-items center
  justify-content center
  color #2BC15D
  .iconfont
    font-size 108px
    line-height 1
.title
  margin-top 28px
  font-weight 600
  font-size 36px
  color #3D3D3D
  line-height 50px

.desc
  margin-top 18px
  font-size 22px
  color #666666
  line-height 34px

.view-btn
  margin-top 42px
  min-width 220px
  height 44px
  color #fff
  background-color #C8161D
  border-color #C8161D
  border-radius 4px
  font-size 16px
  line-height: 1;
  border: 0
  &:hover
    background-color #E24147
    border-color #E24147
</style>
